import React from 'react';
import Image from '../../pics';

function splservice() {
  return (
    <div>
        <div className="uk-section uk-visible@m">
            <div className="uk-container">
                <div className="uk-child-width-1-2@m uk-grid-small uk-grid-match uk-text-left align-items-center" data-uk-grid>
                    <div>
                        <div className="uk-card uk-card-body">
                            <h3 className="uk-card-title text-primary">
                                Domestic Courier Service
                            </h3>
                            <p className='uk-text-justify text-secondary'>
                                Do you have Small sample parcels or small commercial shipments? Our domestic courier service ensures swift and reliable delivery to many destination across India, With our extensive network and dedicated team, you can trust us to handle your shipments with care and efficiency.
                            </p>
                        </div>
                    </div>
                    <div className='text-center'>
                        <div className="uk-card-body">
                            <img src={Image.DOMESTIC} alt='domestic courier' width="80%" height="50%"/>
                        </div>
                    </div>
                    <div className='text-center'>
                        <div className="uk-card-body">
                            <img src={Image.D2DCARGO} alt='door to door' width="80%" height="50%"/>
                        </div>
                    </div>
                    <div>
                        <div className="uk-card uk-card-body">
                            <h3 className="uk-card-title text-primary">
                                Door to Door Air Cargo Service
                            </h3>
                            <p className='uk-text-justify text-secondary'>
                                When you need to transport your bulk goods quickly, easier & care free, our door to door air cargo services are the ideal solution. Designed to meet the speed and reliability requirements of businesses, our air cargo services ensure efficient delivery of your goods. Additionally, we have got you covered with comprehensive insurance for your goods, providing peace of mind in case of any unforeseen events.
                            </p>
                        </div>
                    </div>
                    
                    <div>
                        <div className="uk-card uk-card-body">
                            <h3 className="uk-card-title text-primary">
                                Airport to Airport Cargo Service
                            </h3>
                            <p className='uk-text-justify text-secondary'>
                                Streamline your logistics across India and World wide with our airport to airport  cargo service. Drop your cargo at an airport. Rest assured, we will ensure your cargo reaches its destination airport seamlessly and on time it will be available to collect by the consignee.  Most suitable service for perishable goods at an affordable cost. 
                            </p>
                        </div>
                    </div>
                    <div className='text-center'>
                        <div className="uk-card-body">
                            <img src={Image.AIRPORT} alt='Airport to Airport Cargo Service' width="80%" height="50%"/>
                        </div>
                    </div>
                    <div>
                        <div className="uk-card-body">
                            <img src={Image.CHARTED} alt='Cargo Charter Flight Service' width="80%" height="50%"/>
                        </div>
                    </div>
                    <div>
                        <div className="uk-card uk-card-body">
                            <h3 className="uk-card-title text-primary">
                                Cargo Charter Flight Service 
                            </h3>
                            <p className='uk-text-justify text-secondary'>
                                Our cargo charter flights offer a flexible and efficient solution for your larger  or bulk shipments or time-sensitive deliveries, tailored precisely to your needs. Whether you are transporting perishable goods or oversized or over weight cargo, our Cargo Charter Flight Service  provide reliable transportation options, through our partnerships with premium Airline companies. we ensure that even ton-ranged goods are carried with assurance. Additionally, we offer insurance coverage to safeguard your goods against any unexpected situations, providing you with peace of mind throughout the journey.
                            </p>
                        </div>
                    </div>
                    
                </div>    
                <div className="customer">
                    <h2 className='text-primary uk-text-center'>
                        Customer Portal and Guarantees
                    </h2>
                    <p className='text-secondary'>
                        Registered customers gain access to their portal for booking waybill, shipment history, invoices, and payment gateway. Our guarantee of on-time, secured, fast, and reliable pick up & deliveries reflects our unwavering commitment to customer satisfaction. Experience excellence in logistics today.
                    </p>
                </div>
            </div>
        </div>
        <div className="uk-section uk-hidden@m">
            <div className="uk-container">
                <div className="uk-child-width-1-2@m uk-grid-small uk-grid-match uk-text-left align-items-center" data-uk-grid>
                    <div>
                        <div className="uk-card uk-card-body">
                            <h3 className="uk-card-title text-primary">
                                Domestic Courier Service
                            </h3>
                            <p className='uk-text-justify text-secondary'>
                                Do you have Small sample parcels or small commercial shipments? Our domestic courier service ensures swift and reliable delivery to many destination across India, With our extensive network and dedicated team, you can trust us to handle your shipments with care and efficiency.
                            </p>
                        </div>
                    </div>
                    <div className='text-center'>
                        <div className="uk-card-body">
                            <img src={Image.DOMESTIC} alt='domestic courier' width="80%" height="50%"/>
                        </div>
                    </div>
                    
                    <div>
                        <div className="uk-card uk-card-body">
                            <h3 className="uk-card-title text-primary">
                                Door to Door Air Cargo Service
                            </h3>
                            <p className='uk-text-justify text-secondary'>
                                When you need to transport your bulk goods quickly, easier & care free, our door to door air cargo services are the ideal solution. Designed to meet the speed and reliability requirements of businesses, our air cargo services ensure efficient delivery of your goods. Additionally, we have got you covered with comprehensive insurance for your goods, providing peace of mind in case of any unforeseen events.
                            </p>
                        </div>
                    </div>
                    <div className='text-center'>
                        <div className="uk-card-body">
                            <img src={Image.D2DCARGO} alt='door to door' width="80%" height="50%"/>
                        </div>
                    </div>
                    <div>
                        <div className="uk-card uk-card-body">
                            <h3 className="uk-card-title text-primary">
                                Airport to Airport Cargo Service
                            </h3>
                            <p className='uk-text-justify text-secondary'>
                                Streamline your logistics across India and World wide with our airport to airport  cargo service. Drop your cargo at an airport. Rest assured, we will ensure your cargo reaches its destination airport seamlessly and on time it will be available to collect by the consignee.  Most suitable service for perishable goods at an affordable cost. 
                            </p>
                        </div>
                    </div>
                    <div className='text-center'>
                        <div className="uk-card-body">
                            <img src={Image.AIRPORT} alt='Airport to Airport Cargo Service' width="80%" height="50%"/>
                        </div>
                    </div>
                    
                    <div>
                        <div className="uk-card uk-card-body">
                            <h3 className="uk-card-title text-primary">
                                Cargo Charter Flight Service 
                            </h3>
                            <p className='uk-text-justify text-secondary'>
                                Our cargo charter flights offer a flexible and efficient solution for your larger  or bulk shipments or time-sensitive deliveries, tailored precisely to your needs. Whether you are transporting perishable goods or oversized or over weight cargo, our Cargo Charter Flight Service  provide reliable transportation options, through our partnerships with premium Airline companies. we ensure that even ton-ranged goods are carried with assurance. Additionally, we offer insurance coverage to safeguard your goods against any unexpected situations, providing you with peace of mind throughout the journey.
                            </p>
                        </div>
                    </div>
                    <div>
                        <div className="uk-card-body">
                            <img src={Image.CHARTED} alt='Cargo Charter Flight Service' width="80%" height="50%"/>
                        </div>
                    </div>
                </div>    
                <div className="customer">
                    <h2 className='text-primary'>
                        Customer Portal and Guarantees
                    </h2>
                    <p className='text-secondary uk-text-justify'>
                        Registered customers gain access to their portal for booking waybill, shipment history, invoices, and payment gateway. Our guarantee of on-time, secured, fast, and reliable pick up & deliveries reflects our unwavering commitment to customer satisfaction. Experience excellence in logistics today.
                    </p>
                </div>
            </div>
        </div>
    </div>
  )
}

export default splservice